export default {
	"start": "Стартовый отчет",
	"standard": "Стандартный отчет",
	"full": "Полный отчет",
	"empty": "Для исследования"
}